import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { ICON } from '@core/util/icon';
import { TITLE_SEARCH_MATTER_STATE } from '@models/matter';
import { UntilDestroy, untilDestroyed } from '@ngneat/until-destroy';
import { Select } from '@ngxs/store';
import { MatterDispatch } from '@state/matter';
import { SelectedMatter } from '@state/matter/matter.selectors';
import { Observable } from 'rxjs';
import { take } from 'rxjs/operators';

@UntilDestroy()
@Component({
	selector: 'app-no-saved-writs',
	templateUrl: './no-saved-writs.component.html',
	styleUrls: ['./no-saved-writs.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
	standalone: false,
})
export class NoSavedWritsComponent {
	ICON = ICON;
	@Select(SelectedMatter.id) id$!: Observable<string>;
	@Input() hideButton = false;

	constructor(private dispatch: MatterDispatch) {}

	searchForWritClick(): void {
		this.id$.pipe(untilDestroyed(this), take(1)).subscribe((matterId) => {
			this.dispatch.SetTitleState(matterId, TITLE_SEARCH_MATTER_STATE.WRITS);
		});
	}
}
